export default __webpack_public_path__ + "static/ilves-abe14c4b4cc1eaaa08c4e14074b4f11b.jpg";